// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BusinessFilledSvg from "@fishx/icons-svg/es/asn/BusinessFilled";
import FishxIcon from '../components/FishxIcon';

var BusinessFilled = function BusinessFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BusinessFilledSvg
  }));
};

BusinessFilled.displayName = 'BusinessFilled';
export default React.forwardRef(BusinessFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BusinessFilled.js
// module id = 2135
// module chunks = 0